/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Select_PromptInputs */

const en_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a list from the menu on the left`)
};

const fr_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner une liste dans le menu a gauche`)
};

const de_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Liste aus dem Menü links aus.`)
};

const it_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un elenco dal menu a sinistra`)
};

const ru_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите список из меню слева.`)
};

const es_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione una lista del menú de la izquierda`)
};

const zh_cn2_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从左侧菜单中选择一个列表。`)
};

const ja_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左側のメニューからリストを選択してください`)
};

const hi_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया बाईं ओर दिए गए मेनू से एक सूची चुनें।`)
};

const pt_pt2_style_guide_manager_select_prompt = /** @type {(inputs: Style_Guide_Manager_Select_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma lista no menu à esquerda.`)
};

/**
* | output |
* | --- |
* | "Please select a list from the menu on the left" |
*
* @param {Style_Guide_Manager_Select_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_select_prompt = /** @type {((inputs?: Style_Guide_Manager_Select_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Select_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_select_prompt(inputs)
	if (locale === "de") return de_style_guide_manager_select_prompt(inputs)
	if (locale === "it") return it_style_guide_manager_select_prompt(inputs)
	if (locale === "ru") return ru_style_guide_manager_select_prompt(inputs)
	if (locale === "es") return es_style_guide_manager_select_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_select_prompt(inputs)
	if (locale === "ja") return ja_style_guide_manager_select_prompt(inputs)
	if (locale === "hi") return hi_style_guide_manager_select_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_select_prompt(inputs)
	return en_style_guide_manager_select_prompt(inputs)
});